import React, { useState } from 'react';
import { TopBar } from './components/TopBar';
import { Sidebar } from './components/Sidebar';
import { HeroSection } from './components/HeroSection';
import { KPIRow } from './components/KPIRow';
import { ConversationPreview } from './components/ConversationPreview';
import { ActiveRecruitments } from './components/ActiveRecruitments';
import { OnboardingTracking } from './components/OnboardingTracking';
import { DemoView } from './components/demo/DemoView';
export function App() {
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const [demoText, setDemoText] = useState<string | null>(null);

  // La démonstration s'ouvre en plein écran : la conversation est
  // l'écran principal, pas un panneau dans le tableau de bord.
  if (demoText !== null) {
    return <DemoView initialText={demoText} onExit={() => setDemoText(null)} data-id="element-0" data-mp="28tw6guwdqq51" />;
  }
  return <div className="flex min-h-screen w-full bg-canvas font-sans text-ink" data-id="element-1" data-mp="23vcmh01cjofb">
      <Sidebar data-id="element-2" data-mp="23t8h0dnsuhcx" />
      {isNavigationOpen && <>
          <button type="button" aria-label="Fermer le menu" className="fixed inset-0 z-40 bg-ink/30 md:hidden" onClick={() => setIsNavigationOpen(false)} data-id="element-3" data-mp="3iiwasc8k4vxf" />
          <Sidebar mobile onClose={() => setIsNavigationOpen(false)} data-id="element-4" data-mp="3rcsw5otwe4bs" />
        </>}
      <div className="min-w-0 flex-1" data-id="element-5" data-mp="4n5i12o8na1">
        <TopBar onMenuToggle={() => setIsNavigationOpen(true)} data-id="element-6" data-mp="7ssnarqpf34" />
        <main className="pb-16" data-id="element-7" data-mp="2zmo4r67q0h12">
          <HeroSection onStart={setDemoText} data-id="element-8" data-mp="2zng2onosiqui" />
          <div className="px-5 sm:px-8" data-id="element-9" data-mp="33nq6put0v76q">
            <KPIRow data-id="element-10" data-mp="33orki71fa7s5" />
          </div>
          <ConversationPreview data-id="element-11" data-mp="38l8gfnev5qfs" />
          <ActiveRecruitments data-id="element-12" data-mp="38l017ov9q91f" />
          <OnboardingTracking data-id="element-13" data-mp="38o4fxg6d0n6c" />
        </main>
      </div>
    </div>;
}